module.exports = __webpack_public_path__ + "img/gonggao.1095b5c9.png";